export default {
  rowLabel: "expense {{name}} on {{date}}",
  expenses: "Expenses",
  expense: "Expense",
  invoiced: "invoiced",
  statusDraft: "draft",
  bulk: {
    addToInvoice: "Add to existing invoice",
    oneClient:
      "Pick expenses from a single client — an invoice belongs to one client.",
    notInvoiceable:
      "Only recorded, uninvoiced expenses in a single currency can be added to an invoice.",
    chooseInvoice: {
      title: "Choose an invoice",
      subtitle: "Draft invoices for {{client}}, in {{currency}}.",
      empty: "No draft invoices for this client.",
      itemCount_one: "{{count}} item",
      itemCount_other: "{{count}} items",
    },
    append: "Append to {{number}}",
  },
  listTitle: "Expenses",
  createTitle: "Add Expense",
  editTitle: "Edit Expense",
  vendor: "Vendor",
  date: "Date",
  category: "Category",
  project: "Project",
  client: "Client",
  description: "Description",
  subtotal: "Subtotal",
  taxAmount: "Tax",
  taxDescription: "Tax description",
  feesAmount: "Fees",
  feesDescription: "Fees description",
  total: "Total",
  status: "Status",
  source: "Source",
  attachments: "Attachments",
  attachmentProcessed: "Receipt read. Fields may have been filled in.",
  attachmentProcessingFailed: "Receipt could not be read.",
  recorded: "Recorded",
  draft: "Draft",
  manualWeb: "Manual",
  email: "Email",
  createSuccess: "Expense created successfully",
  updateSuccess: "Expense updated successfully",
  deleteSuccess: "Expense deleted successfully",
  deleteSuccess_plural: "Expenses deleted successfully",
  deleteError:
    "Sorry, this expense could not be deleted due to an error on our end. Please try again later.",
  confirmDeleteTitle: "Delete Expense",
  confirmDeleteTitle_plural: "Delete Expenses",
  confirmDeleteMessage: "Are you sure you want to delete this expense?",
  confirmDeleteMessage_plural:
    "Are you sure you want to delete these {{count}} expenses?",
  noExpenses: "No expenses yet",
  noExpensesDescription:
    "Track your business expenses by adding your first one.",
  addExpense: "Add Expense",
  uploadAttachment: "Upload Attachment",
  deleteAttachment: "Delete Attachment",
  noAttachments: "No attachments",
  filterByCategory: "Category",
  filterByProject: "Project",
  filterByClient: "Client",
  filterByStatus: "Status",
  filterByDate: "Date",
  searchPlaceholder: "Search expenses...",
  currency: "Currency",
  totalHint: "Total should be {{expected}}",
  addAnother: "Add another",
  noDescription: "No description",
  allCategories: "All Categories",
  allProjects: "All Projects",
  allClients: "All Clients",
  allStatuses: "All Statuses",
  review: "Review",
  markReviewed: "Mark as reviewed",
  reopenDraft: "Reopen as draft",
  statusUpdated: "Expense status updated",
  reviewError:
    "Sorry, the expense status could not be updated due to an error on our end. Please try again later.",
  ocr: {
    scanning: "Scanning receipt...",
    succeeded: "Receipt scanned",
    failed: "Couldn't read receipt",
    confidence: "Confidence: {{value}}%",
    autoFilled: "Auto-filled from receipt",
    revert: "Revert",
  },
};
